/* tn-howto.js - tabs and tap-to-play tutorials for the How To Apply page.
 *
 * Deliberately has no dependencies and does nothing on page load beyond
 * selecting the first tab. Nothing about the videos is preloaded: the
 * cover is a lazy <img> and the <video> element does not exist until
 * someone taps. These are the 1080p tutorials, one of which is 67MB, so
 * DO NOT make them autoplay.
 *
 * Note for anyone changing the regex below: this environment's heredocs
 * collapse a doubled backslash, so use regex LITERALS only - a RegExp
 * built from a string silently loses its escapes.
 */
(function () {
  if (window.tnwHowTo) return;
  window.tnwHowTo = true;

  var PLAY = '<span class="tnw-vid__play"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></span>';

  function slug(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function stopAll(root) {
    root.querySelectorAll('video').forEach(function (v) {
      try { v.pause(); } catch (e) {}
    });
  }

  /* Build the <video> on first tap and play it. One play request only -
   * calling load() immediately before play() aborts the pending request
   * and the clip silently never starts. */
  function mount(fig) {
    if (fig.classList.contains('is-on')) {
      var ex = fig.querySelector('video');
      if (ex) { ex.play().catch(function () {}); }
      return;
    }
    var src = fig.getAttribute('data-src');
    if (!src) return;
    var v = document.createElement('video');
    v.setAttribute('playsinline', '');
    v.setAttribute('controls', '');
    v.setAttribute('preload', 'none');
    v.src = src;
    fig.appendChild(v);
    fig.classList.add('is-on');
    v.play().catch(function () {});
  }

  function select(root, key, push) {
    var tabs = root.querySelectorAll('[data-tnw-tab]');
    var panels = root.querySelectorAll('[data-tnw-panel]');
    var found = false;
    panels.forEach(function (p) {
      var on = p.getAttribute('data-tnw-panel') === key;
      if (on) found = true;
      p.hidden = !on;
    });
    if (!found) return false;
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-tnw-tab') === key;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    stopAll(root);
    /* replaceState, not location.hash - setting the hash would jump the
     * page to the anchor and yank the tab row off screen. */
    if (push && window.history && history.replaceState) {
      try { history.replaceState(null, '', '#' + key); } catch (e) {}
    }
    return true;
  }

  function init(root) {
    if (root.getAttribute('data-tnw-ready')) return;
    root.setAttribute('data-tnw-ready', '1');

    var tabs = [].slice.call(root.querySelectorAll('[data-tnw-tab]'));

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tnw-tab]');
      if (tab && root.contains(tab)) {
        e.preventDefault();
        select(root, tab.getAttribute('data-tnw-tab'), true);
        return;
      }
      var btn = e.target.closest('[data-tnw-play]');
      if (btn && root.contains(btn)) {
        e.preventDefault();
        var fig = btn.closest('[data-tnw-vid]');
        if (fig) { stopAll(root); mount(fig); }
      }
    });

    /* Left/right arrows move between tabs, which is what a tablist is
     * expected to do once role=tab is on the buttons. */
    root.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[data-tnw-tab]');
      if (!tab) return;
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var i = tabs.indexOf(tab);
      var next = tabs[(i + d + tabs.length) % tabs.length];
      if (next) {
        select(root, next.getAttribute('data-tnw-tab'), true);
        next.focus();
      }
    });

    /* A product page can link straight to an area, e.g. #neck. */
    var want = slug(location.hash.replace(/^#/, ''));
    if (!want || !select(root, want, false)) {
      var first = tabs[0];
      if (first) select(root, first.getAttribute('data-tnw-tab'), false);
    } else {
      var p = root.querySelector('[data-tnw-panel="' + want + '"]');
      if (p) {
        try {
          root.scrollIntoView({
            block: 'start',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        } catch (e) { root.scrollIntoView(); }
      }
    }

    window.addEventListener('hashchange', function () {
      var k = slug(location.hash.replace(/^#/, ''));
      if (k) select(root, k, false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-tnw-root]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
